import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconClipboard: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconClipboard"><Path fillRule="evenodd" clipRule="evenodd" d="M8 2H16V4H20V22H4V4H8V2ZM9.5 6.5H14.5V3.5H9.5V6.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconClipboard;
